export default "__VITE_ASSET__CQovfvRP__"